import type { QueryClient } from '@tanstack/react-query';
import { warehouseSyncKeys, type WarehouseSync } from './entity';

/**
 * The sync is a workspace singleton, so there is one cache slot per workspace
 * and `null` is a meaningful value in it ("not connected"), distinct from an
 * absent entry ("not loaded").
 */
export function setWarehouseSyncCache(qc: QueryClient, workspaceId: number, sync: WarehouseSync | null): void {
  qc.setQueryData(warehouseSyncKeys.detail(workspaceId, 'current'), sync);
}

export function getWarehouseSyncCache(qc: QueryClient, workspaceId: number): WarehouseSync | null | undefined {
  return qc.getQueryData<WarehouseSync | null>(warehouseSyncKeys.detail(workspaceId, 'current'));
}

/**
 * The integrations directory and connections tab both derive warehouse cards
 * from this record, so connecting or disconnecting has to refresh them too.
 */
export function invalidateWarehouseSync(qc: QueryClient, workspaceId: number): void {
  void qc.invalidateQueries({ queryKey: warehouseSyncKeys.detail(workspaceId, 'current') });
}
